import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Layout, Table, Typography } from "antd";
import Search from "antd/es/input/Search";
import { getInternalTransferParents } from "services/internal-transfer-service";
import { maskCNPJ } from "utils";

const { Content } = Layout;

const InternalTransferParentScreen = () => {
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            try {
                const res = await getInternalTransferParents(query, page, pageSize);
                setData(res.data);
                setTotal(res.total);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [query, page, pageSize]);

    return (
        <Content>
            <Typography.Text type="secondary">
                Selecione uma matriz para visualizar as transferências do grupo.
            </Typography.Text>
            <Table
                rowKey="id"
                style={{ marginTop: 16 }}
                dataSource={data}
                loading={loading}
                bordered
                scroll={{ y: "50vh", x: 800 }}
                title={() => (
                    <Search
                        style={{ maxWidth: 360 }}
                        placeholder="Pesquise por nome ou CNPJ"
                        allowClear
                        onSearch={(value) => {
                            setPage(1);
                            setQuery(value);
                        }}
                    />
                )}
                pagination={{
                    current: page,
                    total,
                    pageSize,
                    showTotal: (total, range) => `${range[1]} de ${total}`,
                    disabled: loading,
                    showSizeChanger: true,
                    onChange: (newPage, newPageSize) => {
                        setPage(newPageSize !== pageSize ? 1 : newPage);
                        setPageSize(newPageSize);
                    }
                }}
            >
                <Table.Column title="Nome Fantasia" dataIndex="fantasyName" key="fantasyName" />
                <Table.Column width={200} align="center" title="CNPJ" dataIndex="cnpj" key="cnpj" render={(value) => (value ? maskCNPJ(value) : "")} />
                <Table.Column width={120} align="center" title="Filiais" dataIndex="childrenCount" key="childrenCount" />
                <Table.Column
                    width={180}
                    align="center"
                    title="Grupo"
                    key="group"
                    render={(_, row) => (
                        <Button type="link" onClick={() => navigate(`/internal-transfer/parent/${row.id}`)}>
                            Visualizar grupo
                        </Button>
                    )}
                />
            </Table>
        </Content>
    );
};

export default InternalTransferParentScreen;
